import { makeStyles, Theme } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import createStyles from "@material-ui/core/styles/createStyles";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import React, { FunctionComponent, ReactNode, useContext } from "react";
import { Link } from "react-router-dom";
import { LinearBuffer } from "../Buffer/LinearBuffer";
import { Logo } from "../Logo/Logo";
import { drawerWidth } from "../SideMenu/SideMenu";
import { UserMenu, UserMenuProps} from "../UserMenu/UserMenu";
import { observer } from "mobx-react-lite";
import { routerContext } from "../../router/RouterStore";

const useStyles = makeStyles((theme: Theme) => {
  const background = theme.palette.background.header;

  return createStyles({
    appBar: {
      background: background,
      color: theme.palette.getContrastText(background),
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      zIndex: theme.zIndex.drawer + 1
    },
    appBarWhenDrawerOpen: {
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    toolBar: {
      marginLeft: -5
    }
  });
});

export interface HeaderProps extends UserMenuProps{
  logoSrc?: any;
  mainTitle?: string;
  hamburgerClick?: () => void;
  landingPageLink?: string;
  children?: ReactNode;
}

const HeaderComponent: FunctionComponent<HeaderProps> = observer(
  (props: HeaderProps) => {
    const classes = useStyles();
    const { hamburgerClick, logoSrc, mainTitle, landingPageLink, buttonConfig } = props;
    const { homeRoute } = useContext(routerContext);

    return (
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <IconButton
            style={{ marginRight: 12 }}
            color="inherit"
            aria-label="Open drawer"
            onClick={hamburgerClick}
          >
            <MenuIcon />
          </IconButton>
          <Link to={landingPageLink ? landingPageLink : `/${homeRoute}`}>
            <Logo
              src={logoSrc}
              hideOnMobile={false}
              image={true}
              imageStyle={{
                marginLeft: 10,
                marginRight: 10,
                marginTop: 8,
                maxWidth: 40
              }}
              color="initial"
              noWrap={true}
            />
          </Link>
          &nbsp;
          <Logo
            hideOnMobile={true}
            image={false}
            title={mainTitle}
            color="initial"
            noWrap={true}
          />
          {props.children}
          <UserMenu buttonConfig={buttonConfig} />
        </Toolbar>
        <LinearBuffer />
      </AppBar>
    );
  }
);

export const Header = HeaderComponent;
